import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AdminBadgeContext = createContext(null);

export function AdminBadgeProvider({ children }) {
  const [unreadMessages, setUnreadMessages] = useState(0);

  const refresh = useCallback(() => {
    api.get("/admin/messages/unread-count")
      .then((r) => setUnreadMessages(r.data.count || 0))
      .catch(() => {});
  }, []);

  const markMessagesSeen = useCallback(async () => {
    setUnreadMessages(0);
    try { await api.post("/admin/messages/mark-seen"); } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30000);
    return () => clearInterval(id);
  }, [refresh]);

  return (
    <AdminBadgeContext.Provider value={{ unreadMessages, refresh, markMessagesSeen }}>
      {children}
    </AdminBadgeContext.Provider>
  );
}

export function useAdminBadges() {
  return useContext(AdminBadgeContext) || { unreadMessages: 0, refresh: () => {}, markMessagesSeen: async () => {} };
}
